import { render, staticRenderFns } from "./StaffFilter.vue?vue&type=template&id=79b62fbf&"
import script from "./StaffFilter.vue?vue&type=script&lang=js&"
export * from "./StaffFilter.vue?vue&type=script&lang=js&"
import style0 from "./StaffFilter.vue?vue&type=style&index=0&id=79b62fbf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports